import { useHeadStore } from '../store/headStore'

export function CalibrateButton() {
  const active = useHeadStore((s) => s.active)
  const calibrate = useHeadStore((s) => s.calibrate)
  const reset = useHeadStore((s) => s.resetCalibration)

  return (
    <div className={`calibrate-button-wrap ${active ? '' : 'is-inactive'}`}>
      <button
        className="calibrate-button"
        onClick={calibrate}
        title="按下时把当前头部姿态当作零点"
        disabled={!active}
      >
        校准
      </button>
      <button
        className="calibrate-button ghost small"
        onClick={reset}
        title="清除当前校准偏移"
        disabled={!active}
      >
        重置
      </button>
    </div>
  )
}
